/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deep_Gold_Frog_BlowInputs */

const en_deep_gold_frog_blow = /** @type {(inputs: Deep_Gold_Frog_BlowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New follow-up`)
};

const de_deep_gold_frog_blow = /** @type {(inputs: Deep_Gold_Frog_BlowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neue Rückfrage`)
};

/**
* | output |
* | --- |
* | "New follow-up" |
*
* @param {Deep_Gold_Frog_BlowInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const deep_gold_frog_blow = /** @type {((inputs?: Deep_Gold_Frog_BlowInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deep_Gold_Frog_BlowInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deep_gold_frog_blow(inputs)
	return de_deep_gold_frog_blow(inputs)
});